import React, { Fragment } from 'react';
import { withStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import CardDisplay from '../CardDisplay';
import AlertPanel from 'components/AlertPanel';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import DropDown from 'components/DropDown';
import FormElement from 'components/FormElement';
import { H2, Body1, Subtitle2, H4, Caption } from 'components/Typography';
import { toShortDateTimeString } from 'utilities/formatters/dateTimeFormatter';
import FatigueInformation from '../FatigueInformation';
import Restrictions from '../Restrictions';
import Breathalyser from '../Breathalyser';
import MissingCompetenciesView from '../MissingCompetenciesView';
import isNotNullOrEmpty from 'utilities/is/isNotNullOrEmpty'
import styles from './styles';
import m from 'messages';
import swipeEvents from 'areas/swipes/domain/swipeEvents';
import displayMode from 'areas/swipes/domain/displayMode';
import isStringSet from 'utilities/is/isStringSet';

class CardHolderDetails extends React.Component {

    constructor(props) {
        super(props);

        let jobRoleID = props.card.selectedJobRoleID;

        this.state = {
            selectedEmployerID: props.card.selectedEmployerID || '',
            selectedJobRoleID: jobRoleID || 'NULL'
        };
    }

    employerChanged = (e) => {
        const employerId = e.target.value;
        this.props.card.selectedEmployerID = employerId;
        this.setState({ selectedEmployerID: employerId });

        if (this.props.hasOwnProperty('handleEmployerChanged')) {
            this.props.handleEmployerChanged(employerId);
        }
    };

    jobRoleChanged = (e) => {
        const jobRoleId = e.target.value;
        this.props.card.selectedJobRoleID = jobRoleId;
        this.setState({ selectedJobRoleID: jobRoleId });

        if (this.props.hasOwnProperty('handleJobRoleChanged')) {
            this.props.handleJobRoleChanged(jobRoleId);
        }
    };

    jobRolesToShow = (jobRoles, currentDivisionId, divisionJobRoleId) => {

        let filtered = (jobRoles || []).filter(j => !isStringSet(j.divisionID) || j.divisionID.toLowerCase() === currentDivisionId);

        if (isStringSet(divisionJobRoleId)) {
            divisionJobRoleId = divisionJobRoleId.toLowerCase();

            let head = filtered.filter(j => j.id.toLowerCase() === divisionJobRoleId);
            let others = filtered.filter(j => j.id.toLowerCase() !== divisionJobRoleId);

            filtered = [{ id: 'NULL', name: m.cards.jobRoleNotSelected, division: '' }].concat(others);

            if (head.length > 0) {
                filtered = head.concat(filtered);
            }
        } else {
            filtered = [{ id: 'NULL', name: m.cards.jobRoleNotSelected, division: '' }].concat(filtered);
        }

        return filtered;
    };

    render() {
        const {
            card,
            classes,
            config,
            employerAndJobRoleEditable,
            showEmployerAndJobRole,
            fatigueDataEditable,
            location,
            viewcontext,
            denyReason
        } = this.props;

        const isRejected = Boolean(denyReason) && Boolean(denyReason.reasonDescription) && denyReason.reasonID !== swipeEvents.FATIGUE_OUTSIDE_WORKING_HOURS_ID
        const isSwipeOut = viewcontext === displayMode.swipeOut;
        const isBlocked = isNotNullOrEmpty(card.suspensions)
            && !(card.isSubscriptionExpired || card.isSubscriptionPending)
            && !isRejected
            && !isSwipeOut;

        const isCompetenceView =
            viewcontext === displayMode.awardCompetence
            || viewcontext === displayMode.awardPendingCompetence
            || viewcontext === displayMode.showCardAwardCompetence;

        const showMissingCompetencies = card.missingCompetences
            && viewcontext !== displayMode.awardCompetence
            && viewcontext !== displayMode.awardPendingCompetence
            && viewcontext !== displayMode.showCardAwardCompetence
            && (isRejected && denyReason.reasonID === swipeEvents.INVALID_COMPETENCES_ID);

        const showFatigueData =
            !card.isMinimalCardDisplay
            && !isCompetenceView
            && card.fatigueInformation
            && (!isRejected || (isRejected && denyReason && denyReason.reasonID === swipeEvents.FATIGUE_OUTSIDE_WORKING_HOURS_ID));
        const jobRolesToShow =
            this.jobRolesToShow(
                card.jobRolesArray,
                location.division.divisionID.toLowerCase(),
                location.division.divisionJobRoleID);

        const selectedJobRoleId = (this.state.selectedJobRoleID || '').toUpperCase();

        return (
            <Grid container>
                {showMissingCompetencies &&
                    <Grid item xs={12}>
                        <MissingCompetenciesView card={card} config={config} location={location} />
                    </Grid>
                }

                <Grid item xs={12}>
                    {isBlocked &&
                        <AlertPanel
                            message={m.cards.blocksPresentAlert}
                            variant="warning"
                            className={classes.alertPanel}
                            action={this.props.showBlockLink && [
                                <Button
                                    key="close"
                                    aria-label="Close"
                                    color="inherit"
                                    className={classes.close}
                                    onClick={this.props.onShowBlocks}>
                                    {m.general.show}
                                    <ArrowRightIcon className={classes.icon} />
                                </Button>
                            ]}
                        />
                    }
                </Grid>
                <Grid item xs={12}>
                    <H2 paragraph>
                        {m.cards.cardDetails}
                    </H2>
                </Grid>

                <Grid container spacing={2} className={classes.margin}>
                    <Grid item xs={12}>
                        <H4 paragraph>{m.cards.cardholderOverviewHeader}</H4>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <CardDisplay card={card} />
                        {card.newToIndustry &&
                            <Caption paragraph className={classes.newToIndustry}>
                                {m.cards.newToIndustry}
                            </Caption>
                        }
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                        <Grid container spacing={0}>
                            <Grid item xs={12}  className={classes.dropdown}>
                                <Subtitle2>
                                    {m.cards.checkedWithDatabase}
                                </Subtitle2>
                                <Body1 paragraph>
                                    {toShortDateTimeString(card.dateRetrieved)}
                                </Body1>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={5} lg={5}>
                        <Grid container spacing={0}>
                            {showEmployerAndJobRole && !isRejected &&
                                <Fragment>
                                    <Grid item xs={12} sm={6} md={6} lg={6}>
                                        <FormElement className={classes.dropdown} fullWidth>
                                            <Subtitle2>
                                                {m.cards.employer}
                                            </Subtitle2>
                                            {employerAndJobRoleEditable &&
                                                <DropDown
                                                    id="employer"
                                                    value={card.selectedEmployerID}
                                                    onChange={this.employerChanged}>
                                                    {card.employersArray.map((item, index) =>
                                                        <MenuItem key={index} value={item.id.toLowerCase()}>{item.name}</MenuItem>
                                                    )}
                                                </DropDown>
                                            }
                                            {!employerAndJobRoleEditable && card.employer &&
                                                <Body1 paragraph>{card.employer.name}</Body1>
                                            }
                                        </FormElement>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6} lg={6}>
                                        <FormElement className={classes.dropdown} fullWidth>
                                            <Subtitle2>
                                                {m.cards.jobRole}
                                            </Subtitle2>
                                            {employerAndJobRoleEditable &&
                                                <DropDown
                                                    value={selectedJobRoleId}
                                                    onChange={this.jobRoleChanged}>

                                                    {jobRolesToShow.map((item, index) =>
                                                        <MenuItem key={index} value={item.id}>{item.name} {item.division ? `(${item.division})` : ''}</MenuItem>
                                                    )}
                                                </DropDown>
                                            }
                                            {!employerAndJobRoleEditable && card.jobRole &&
                                                <Body1 paragraph>{card.jobRole.name + ' (' + card.jobRole.division + ')'}</Body1>
                                            }
                                        </FormElement>
                                    </Grid>
                                </Fragment>
                            }
                            <Grid item xs={12} sm={6} md={6} lg={6} className={classes.dropdown}>
                                <Subtitle2>
                                    {m.cards.mobileNumber}
                                </Subtitle2>
                                <Body1 paragraph>
                                    {card.mobileNumber}
                                </Body1>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6} className={classes.dropdown}>
                                <Subtitle2>
                                    {m.cards.emergencyContactNumber}
                                </Subtitle2>
                                <Body1 paragraph>
                                    {card.emergencyContactNumber}
                                </Body1>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                {!card.isMinimalCardDisplay && !isSwipeOut && !card.isSuspendedBySite &&
                    <Breathalyser card={card} />
                }

                {!card.isMinimalCardDisplay && !isSwipeOut &&
                    <Restrictions card={card} />
                }

                {showFatigueData &&
                    <div className={classes.fatiguePanel}>
                        <FatigueInformation
                            editable={fatigueDataEditable}
                            fatigueInformation={card.fatigueInformation}
                            timeToWorkChanged={this.props.timeToWorkChanged}
                            timeFromWorkChanged={this.props.timeFromWorkChanged} />
                    </div>
                }

            </Grid>);
    }
}

CardHolderDetails.propTypes = {
    card: PropTypes.object.isRequired,
    config: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    denyReason: PropTypes.object,
    employerAndJobRoleEditable: PropTypes.bool,
    showEmployerAndJobRole: PropTypes.bool,
    fatigueDataEditable: PropTypes.bool,
    handleEmployerChanged: PropTypes.func,
    handleJobRoleChanged: PropTypes.func
};

export default withStyles(styles)(CardHolderDetails);